export const AXIS_LABEL_MARGIN_PX = 8;
export const AXIS_LABEL_INTERVAL_ALL = 0;
export const AXIS_LABEL_FONT_SIZE_PX = 12;
export const AXIS_LABEL_FONT_FAMILY = 'Arial, sans-serif';

const AXIS_LABEL_CHAR_WIDTH_PX = 7;

// nameGap is measured from the axis line; echarts has no API for its horizontal position, so estimate the tick width (padded for "nice" tick rounding).
export function estimateNumericAxisTickLabelWidthPx(values: number[], charWidthPx: number = AXIS_LABEL_CHAR_WIDTH_PX): number {
  const maxAbsValue = values.reduce((max: number, value: number) => Math.max(max, Math.abs(value)), 0);
  const formattedLength = Math.ceil(maxAbsValue).toLocaleString('en-US').length;

  return (formattedLength + 2) * charWidthPx;
}
